// ── Legacy assign: neutralized, NOT retired ──────────────────────────────────────────────────
//
// Item 1 gave the tenant one canonical place to assign control work — the Workflow region on the
// control's Overview tab, writing `cts_assignments`. The legacy pages still reachable at
// /compliance/controls/:frameworkId[/:controlId] carry their own assign affordances writing
// `compliance_control_assignments` and `pol_compliance_scope_assignments`. Two live write paths
// into two different stores is how a tenant ends up with work that only half the product can see.
//
// ⚠ SO THE WRITES ARE TURNED OFF AT THE AFFORDANCE, AND NOTHING ELSE IS TOUCHED. No service, no
// endpoint, no table, no row: retiring the legacy machine is TC6's, and it is gated on facts this
// sprint did not establish. Existing rows keep rendering — the READ views are untouched, because a
// tenant who was assigned work last month must still be able to see it.
//
// ⚠ AND A NEUTRALIZED CONTROL MUST READ AS INTENTIONAL, NOT BROKEN. Each disabled affordance
// carries this sentence, which says where the action went rather than merely that it is gone —
// a disabled button with no explanation is the failure this codebase has banked twice.
//
// ⓘ Scope assignment is neutralized too. It looks like a different feature, but it MATERIALISES
// `compliance_control_assignments` rows server-side, so hiding only the per-control panel would
// have left a second door open — the finding that Phase-A verification turned up.

export const LEGACY_ASSIGN_MOVED =
  "Assigning has moved — open the control and use the Workflow card on its Overview tab.";
